import Role from "./Role.js";

/**
 * `CountryUserRole` describes permissions of a country user over other users.
 */
export default class CountryUserRole extends Role {
	canDeleteUser(user) {
		return user
			.getRoles()
			.every((role) => role.canBeDeletedByCountryUser(this));
	}

	canBeDeletedByCountryUser(role) {
		return this._isForSameCountry(role);
	}

	canAttachOrDetachCompanyId(user, companyId) {
		return user
			.getRoles()
			.some((role) =>
				role.canCompanyIdBeAttachedOrDetachedByCountryUser(
					this,
					companyId,
				),
			);
	}

	canEditUserInfo(user) {
		return user
			.getRoles()
			.some((role) => role.canUserInfoBeEditedByCountryUser(this));
	}

	canUserInfoBeEditedByCountryUser(role) {
		return this._isForSameCountry(role);
	}

	canViewAccountingDocuments() {
		return true;
	}

	canViewBudgetEditor() {
		return true;
	}

	canAdministrateAgency(agency) {
		return agency.getCountryId() === this.getCountryId();
	}

	canCreatePeriodReports() {
		return true;
	}

	canAdministrateDocumentArchive() {
		return true;
	}

	canChangeCompanyPackage() {
		return true;
	}

	canManagePackages() {
		return true;
	}

	//
	// canUpgradeSubscriptionPlan
	//

	canUpgradeSubscriptionPlanForCompany() {
		return true;
	}

	canExtractDataFromCompany(_company) {
		return true;
	}

	canDeleteCompany(_company) {
		return true;
	}

	canShareChartOfAccounts() {
		return true;
	}
}
